import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const ContactsEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		id: yup.string().required().label("Id"),
		phonenumber: yup.string().required().label("Phonenumber"),
		name: yup.string().nullable().label("Name"),
		lastmessage: yup.string().nullable().label("Lastmessage"),
		lastmessagetime: yup.string().nullable().label("Lastmessagetime"),
		createdat: yup.string().nullable().label("Createdat"),
		updatedat: yup.string().nullable().label("Updatedat")
	});
	// form default values
	const formDefaultValues = {
		id: '', 
		phonenumber: '', 
		name: '', 
		lastmessage: '', 
		lastmessagetime: new Date(), 
		createdat: "(getutcdate())", 
		updatedat: "(getutcdate())", 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/contacts`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="ContactsEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Edit Contact"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Id *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="id"  onChange={formik.handleChange}  value={formik.values.id}   label="Id" type="text" placeholder="Enter Id"        className={inputClassName(formik?.errors?.id)} />
                                                <ErrorMessage name="id" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Phonenumber *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="phonenumber"  onChange={formik.handleChange}  value={formik.values.phonenumber}   label="Phonenumber" type="text" placeholder="Enter Phonenumber"        className={inputClassName(formik?.errors?.phonenumber)} />
                                                <ErrorMessage name="phonenumber" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Name 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="name"  onChange={formik.handleChange}  value={formik.values.name}   label="Name" type="text" placeholder="Enter Name"        className={inputClassName(formik?.errors?.name)} />
                                                <ErrorMessage name="name" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Lastmessage 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="lastmessage"  onChange={formik.handleChange}  value={formik.values.lastmessage}   label="Lastmessage" type="text" placeholder="Enter Lastmessage"        className={inputClassName(formik?.errors?.lastmessage)} />
                                                <ErrorMessage name="lastmessage" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Lastmessagetime 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="lastmessagetime" value={formik.values.lastmessagetime} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.lastmessagetime)}        />
                                                <ErrorMessage name="lastmessagetime" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Createdat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="createdat" value={formik.values.createdat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.createdat)}        />
                                                <ErrorMessage name="createdat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Updatedat 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="updatedat" value={formik.values.updatedat} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.updatedat)}        />
                                                <ErrorMessage name="updatedat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label="Update" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
ContactsEditPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'contacts',
	apiPath: 'contacts/edit',
	routeName: 'contactsedit',
	submitButtonLabel: "Update",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Update Record",
	msgAfterSave: "Record updated successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default ContactsEditPage;
